/* ==========================================================================
   ALBEUX PRODUCT PAGE: THE TITLE, PRICE AND SAVE COME OUT LETTER BY LETTER, EXACTLY LIKE THE COLLECTION HEADING (3 Nov 2026).
   Pairs with assets/albeux-letters.css. Loaded from snippets/view-transition-opt-in.liquid.
   WHAT IT DOES: on the very frame a product page has finished sliding in (event albeux:landed, sent by albeux-slide-speed.js), the details are shown at once (class alb-landed),
   and the title, the price and the Save text are cut into letters, the way albeux-reveal.js cuts a collection heading. The FIRST letter of each stays where it belongs and is visible
   at once. Every other letter comes out from behind it and slides to the right into its place, fading in as it leaves: same length (1.8 s), same curve (cubic-bezier(0.5, 0, 0.15, 1)),
   same fade (solid by 40%), same start frame for all letters. The further along the word, the further the letter travels, so they fan out one after another.
   The page that slid in has two copies (the sliding one, then the real one it is swapped for a moment later). Both are lettered on the same frame, so the swap cannot be seen.
   The other lines of the details (colours, offers, Add to bag, description) keep their own opening from albeux-pdp-rise.css, now starting on the same frame as well.
   Safety: if anything fails the text is simply shown as it is. Pages opened any other way (no slide), reduced-motion visitors and the theme editor are not touched.
   Only transform and opacity move. To switch it off, delete the albeux-letters lines in snippets/view-transition-opt-in.liquid. */
(function () {
  'use strict';
  if (window.__albLetters) return;
  window.__albLetters = true;
  var d = document.documentElement;
  try {
    if (d.classList.contains('shopify-design-mode') || !Element.prototype.animate) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  } catch (e) { return; }

  var EASE = 'cubic-bezier(0.5, 0, 0.15, 1)';
  var DUR = 1800;
  var MAX = 140;
  var MAIN = "main[data-template^='product']";
  var BLOCKS = '.product-details > .group-block > .group-block-content > .group-block > .group-block-content > *';

  function skipped(node, root) {
    var p = node.parentNode;
    while (p && p !== root && p.nodeType === 1) {
      try { if (p.matches('script,style,svg,noscript,template,.visually-hidden,.sr-only,[hidden],.hidden,[aria-hidden="true"]')) return true; } catch (e) {}
      p = p.parentNode;
    }
    return false;
  }

  /* Cut the visible text of a block into letters; returns the letters (first one first) or null */
  function cut(block) {
    var walker = document.createTreeWalker(block, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) {
      if (/\S/.test(n.nodeValue) && !skipped(n, block)) nodes.push(n);
    }
    if (!nodes.length) return null;
    var total = 0;
    nodes.forEach(function (t) { total += t.nodeValue.replace(/\s+/g, '').length; });
    if (total < 2 || total > MAX) return null;
    var chars = [];
    nodes.forEach(function (t) {
      var frag = document.createDocumentFragment();
      var plain = document.createElement('span');
      plain.className = 'visually-hidden';
      plain.textContent = t.nodeValue.replace(/\s+/g, ' ').trim();
      frag.appendChild(plain);
      t.nodeValue.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
        var w = document.createElement('span');
        w.className = 'alb-lt__w';
        w.setAttribute('aria-hidden', 'true');
        Array.from(part).forEach(function (ch) {
          var c = document.createElement('span');
          c.className = 'alb-lt';
          c.textContent = ch;
          w.appendChild(c);
          chars.push(c);
        });
        frag.appendChild(w);
      });
      t.parentNode.replaceChild(frag, t);
    });
    return chars;
  }

  function run(block) {
    if (block.getAttribute('data-alb-lt')) return;
    block.setAttribute('data-alb-lt', '1');
    try {
      var chars = cut(block);
      if (!chars || chars.length < 2) { block.removeAttribute('data-alb-lt'); return; }
      chars[0].className += ' alb-lt--a';
      var rects = chars.map(function (c) { return c.getBoundingClientRect(); });
      var ar = rects[0];
      for (var i = 1; i < chars.length; i++) {
        (function (c, r) {
          var dx = ar.left - r.left;
          var dy = ar.top - r.top;
          var a = c.animate([
            { transform: 'translate3d(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px,0)', opacity: 0, offset: 0 },
            { opacity: 1, offset: 0.4 },
            { transform: 'translate3d(0,0,0)', opacity: 1, offset: 1 }
          ], { duration: DUR, easing: EASE, fill: 'both' });
          a.onfinish = function () { try { a.cancel(); } catch (e) {} };
        })(chars[i], rects[i]);
      }
    } catch (e) {}
  }

  function processMain(main) {
    try {
      var list = main.querySelectorAll(BLOCKS);
      for (var i = 0; i < list.length; i++) run(list[i]);
    } catch (e) {}
  }

  /* The page that has just slid in lives in the sliding frame (fixed, z-index 41, a direct child of body): letter only that one, never a page hidden behind it */
  function processSliding() {
    var kids = document.body.children;
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (el.tagName !== 'DIV' || el.style.position !== 'fixed' || el.style.zIndex !== '41') continue;
      var mains = el.querySelectorAll(MAIN);
      for (var j = 0; j < mains.length; j++) processMain(mains[j]);
    }
  }

  /* The real copy of the page is built a moment after the slide lands: letter it on the same frame as the sliding copy */
  function watchReal() {
    try {
      var timer = 0;
      var mo = new MutationObserver(function (recs) {
        for (var i = 0; i < recs.length; i++) {
          var added = recs[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && n.matches && n.matches(MAIN)) {
              processMain(n);
              mo.disconnect();
              clearTimeout(timer);
              return;
            }
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
      timer = setTimeout(function () { mo.disconnect(); }, 2500);
    } catch (e) {}
  }

  document.addEventListener('albeux:landed', function () {
    try {
      /* the details are shown on this very frame (they were held back, unseen, until the page landed) */
      d.classList.add('alb-landed');
      processSliding();
      watchReal();
    } catch (e) {}
  });
})();
